import { useContext, useEffect, useState } from "react";
import { CashflowItemDto } from "../../../../dtos/catalogs/cashflowitem/CashflowItemDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import CashflowItemDetailSkeleton from "./CashflowItemDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import CashFlowItemDetailMain from "./CashFlowItemDetailMain";

interface IProps {
  model: CashflowItemDto | null;
  modelUpdatedEvent: (newModel: CashflowItemDto) => void;
}

interface CashfloItemModel {
  id: string;
  name: string;
  createdDate: Date;
  belongTo: number;
}

export const CashFlowItemDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const BelongTo = [
    { id: 0, name: "OperatingActivity" },
    { id: 1, name: "InvestmentActivity" },
    { id: 2, name: "FinancialActivity" }
  ];
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CashfloItemModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("createdDate", model.createdDate);
      setValue("belongTo", model.belongTo);
      // setValue("createdDate", model.createdDate);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: CashfloItemModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    if (action === "save") {
      const newModel: CashfloItemModel = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <CashflowItemDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CashFlowItemDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
